import {Address, IAddress} from "./address";
import {
  ILegalInformation,
  LegalEntityInformation,
  LegalInformation,
  NaturalPersonInformation
} from "./legal-information";
import {ITaxInformation, TaxInformation} from "./tax-information";
import {LegalType} from "./legal-type";

export interface IShard {
  id: string | undefined;
  name: string;
  address: IAddress;
  isPreferredAddress: boolean;
  legalInformation: ILegalInformation | undefined;
  taxInformation: ITaxInformation | undefined;
  metadata: { [key: string]: string | undefined } | undefined;

  setMetadata(key: string, value: string | undefined): void;

  setLegalType(type?: LegalType): void;

  setTaxInformation(inherited: boolean): void;
}

export class Shard implements IShard {
  isPreferredAddress: boolean = false;
  metadata: { [key: string]: string | undefined; } | undefined;
  address: IAddress = new Address();
  id: string | undefined;
  legalInformation: ILegalInformation | undefined;
  name: string = '';
  taxInformation: ITaxInformation | undefined;

  static parse(obj: any): Shard {
    const shard = new Shard();
    shard.id = obj.id;
    shard.name = obj.name;
    shard.address = Address.parse(obj.address);
    shard.isPreferredAddress = obj.isPreferredAddress;
    shard.legalInformation = !obj.legalInformation ? undefined : LegalInformation.parse(obj.legalInformation);
    shard.taxInformation = obj.taxInformation ? TaxInformation.parse(obj.taxInformation) : undefined;
    shard.metadata = obj.metadata ? {...obj.metadata} : undefined;
    return shard;
  }

  setMetadata(key: string, value: string | undefined): void {
    console.log(key, value);
    if (!this.metadata) this.metadata = {};
    this.metadata[key] = value;
    console.log(this.metadata);
  }

  setLegalType(type?: LegalType): void {
    if (!confirm("Durch die Änderung des Rechtstyps werden alle rechtlichen Informationen gelöscht. Möchten Sie fortfahren?")) {
      return;
    }

    switch (type) {
      case LegalType.LegalEntity:
        this.legalInformation = new LegalEntityInformation();
        break;
      case LegalType.NaturalPerson:
        this.legalInformation = new NaturalPersonInformation();
        break;
      default:
        this.legalInformation = undefined;
        break;
    }

    this.setPreferredAddress();
  }

  setTaxInformation(inherited: boolean): void {
    if (!confirm("Durch die Änderung der Steuerinformationen werden alle bestehenden Steuerinformationen gelöscht. Möchten Sie fortfahren?")) {
      return;
    }

    if (inherited) {
      this.taxInformation = undefined;
    } else {
      this.taxInformation = new TaxInformation();
    }

    this.setPreferredAddress();
  }

  private setPreferredAddress() {
    this.isPreferredAddress = this.taxInformation != undefined || this.legalInformation != undefined;
  }
}
